import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  imports: [AsyncPipe, IconComponent],
  selector: 'aux-stage-indicator',
  template: `
    <div class="flex items-center space-x-1 rounded bg-white p-1 text-sm text-aux-blue-dark">
      @if (isSandboxEnv$ | async) {
        <aux-icon name="Box" />
      } @else {
        <aux-icon name="SettingsBolt" />
      }

      <p>{{ envName$ | async }}</p>
    </div>
  `,
})
export class StageIndicatorComponent {
  private launchDarklyService = inject(LaunchDarklyService);

  envName$ = this.launchDarklyService.envName$;
  isSandboxEnv$ = new BehaviorSubject(false);

  constructor() {
    this.envName$.pipe(takeUntilDestroyed()).subscribe((envName) => {
      this.isSandboxEnv$.next(!!envName.match('-sandbox'));
    });
  }
}
